import { j as s } from "../../../node_modules/react/jsx-runtime.js";
import { cssTransition as h, ToastContainer as v, Slide as C, toast as u } from "../../../node_modules/react-toastify/dist/react-toastify.esm.js";
import { clsx as r } from "../../../node_modules/clsx/dist/clsx.m.js";
/* empty css                                                          */
import { FeaturedIcon as N } from "../FeaturedIcon/FeaturedIcon.js";
import { Typography as m } from "../Typography/Typography.js";
import T from "../CompactButton/CompactButton.js";
import d from "../Button/Button.js";
import t from "./Toast.module.scss.js";
import { getLocale as b } from "../../../utils/helper.js";
/* empty css                */
const w = {
  info: "info-circle-filled",
  warning: "alert-triangle-filled",
  success: "check-circle-filled",
  danger: "alert-octagon-filled"
}, k = h({
  enter: "toast-enter",
  exit: "toast-exit",
  appendPosition: !1
}), B = ({
  closeToast: o
}) => /* @__PURE__ */ s.jsx("div", { className: t.ToastifyToast, children: /* @__PURE__ */ s.jsx(
  T,
  {
    size: "small",
    icon: "x-close",
    variant: "ghost",
    onClick: o,
    testId: "toast-close"
  }
) }), z = () => {
  u.clearWaitingQueue();
}, S = () => /* @__PURE__ */ s.jsx(
  v,
  {
    className: t.toasterContainer,
    position: "top-right",
    newestOnTop: !1,
    hideProgressBar: !0,
    transition: C,
    pauseOnFocusLoss: !0,
    draggable: !0,
    limit: 3,
    onClick: z,
    pauseOnHover: !0,
    autoClose: !1
  }
), A = ({
  label: o,
  type: e = "info",
  testId: a,
  description: l,
  close: n,
  dismissLabel: f = "Dismiss",
  undoLabel: x = "Undo",
  autoClose: p,
  onClickDismiss: g,
  onCloseUndo: j,
  actions: c,
  rtl: i = b() === "ar"
}) => {
  u(
    /* @__PURE__ */ s.jsxs(
      "div",
      {
        className: r(t.toast, t[e]),
        "data-testid": a,
        dir: i ? "rtl" : "ltr",
        children: [
          /* @__PURE__ */ s.jsx("div", { className: r(t.circleGlowToast, t[`${e}CircleGlow`]) }),
          /* @__PURE__ */ s.jsxs("div", { className: t.inner, children: [
            /* @__PURE__ */ s.jsxs("div", { className: t.labelAction, children: [
              /* @__PURE__ */ s.jsx("div", { className: t.featuredIconContainer, children: /* @__PURE__ */ s.jsx(
                N,
                {
                  variant: e === "success" ? "outline" : "tinted",
                  iconName: w[e],
                  colorType: e,
                  rounded: !0,
                  size: "sm"
                }
              ) }),
              /* @__PURE__ */ s.jsxs("div", { className: t.frame, children: [
                o && /* @__PURE__ */ s.jsx("div", { className: t.toastLabel, children: /* @__PURE__ */ s.jsx(
                  m,
                  {
                    text: o,
                    variant: "body-new/semibold",
                    textColor: "color/fg/default",
                    testId: `${a}-label`
                  }
                ) }),
                l && /* @__PURE__ */ s.jsx(
                  "p",
                  {
                    className: r(t.toastDesc, {
                      "me-300": !o
                    }),
                    children: /* @__PURE__ */ s.jsx(
                      m,
                      {
                        text: l,
                        variant: "body-new/regular",
                        textColor: "color/fg/light",
                        testId: `${a}-description`
                      }
                    )
                  }
                )
              ] })
            ] }),
            c && /* @__PURE__ */ s.jsxs("div", { className: t.buttonsWrapper, children: [
              /* @__PURE__ */ s.jsx(
                d,
                {
                  size: "small",
                  variant: "ghost",
                  label: f,
                  onClick: g,
                  color: "neutral"
                }
              ),
              /* @__PURE__ */ s.jsx(
                d,
                {
                  size: "small",
                  variant: "tinted",
                  label: x,
                  onClick: j,
                  color: "neutral"
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ s.jsx("div", { className: "circle-glow" })
        ]
      }
    ),
    {
      closeOnClick: !(n || c),
      closeButton: n ? B : !1,
      position: i ? "top-left" : "top-right",
      transition: k,
      rtl: i,
      autoClose: p || !1
    }
  );
};
export {
  S as default,
  A as showToast
};
//# sourceMappingURL=Toast.js.map
